var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitbucketLogoRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "108.66%",
    x2: "46.93%",
    y1: "13.81%",
    y2: "78.79%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "18%",
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2684FF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.31 22.34h7.53l1.82-10.6H12.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    fillRule: "nonzero",
    d: "M1.21.85A1.16 1.16 0 0 0 .07 2.19L5 31.93c.13.75.77 1.3 1.53 1.31H30c.58 0 1.06-.43 1.14-1L36 2.2A1.15 1.15 0 0 0 34.86.86L1.21.85zm20.63 21.49h-7.53l-2-10.6h11.35l-1.82 10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M34.48 11.74H23.66l-1.82 10.6h-7.53L5.48 32.86c.28.24.63.37 1 .38H30c.58 0 1.06-.43 1.14-1l3.34-20.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitbucketLogoRgb);
export default __webpack_public_path__ + "static/media/bitbucket-logo-rgb.b3ad91afe809bdc2110bea7baf30dbf1.svg";
export { ForwardRef as ReactComponent };